import React from 'react';
import classNames from 'classnames';
import {
  Table, TableCell, TableRow, TableBody, Body1 as Text
} from '@fluentui/react-components';

import { TableShimmer } from './shimmer';
import { LOCATIONS_PER_PAGE } from '../utils/const';
import { getPageLocations } from '../utils/get-page-locations';
import { TopLocationsTableProps } from '../utils/types';
import { useTableStyles } from '../styles/table-styles';

export function TopLocationsTable({
  i18n,
  isLoading,
  locations,
  paginationConfig,
}: TopLocationsTableProps) {
  const styles = useTableStyles();
  if (isLoading) {
    return <TableShimmer />;
  }
  const rowsToDisplay = getPageLocations(locations, paginationConfig, LOCATIONS_PER_PAGE);
  return (
    <Table sortable className="top-locations-table" arial-label={i18n.getString(_TL_('Top locations table'))}>
      <TableBody>
        {rowsToDisplay.map(({ name, formattedValue }) => (
          <TableRow className="location-row" key={name}>
            <TableCell>
              <Text className="location-name">{name}</Text>
            </TableCell>
            <TableCell>
              <Text className={classNames(styles.value, 'metric-value')}>{formattedValue}</Text>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
